import React from 'react';
import {
    Grid, Row, Col, Tabs, Tab, Table,
    Form, FormGroup, FormControl, ControlLabel,
    OverlayTrigger, Tooltip
} from 'react-bootstrap';
import SweetAlert from "react-bootstrap-sweetalert";
import Slider from "react-slick";
import './slider.css';
import './slider-theme.css'
import Card from '../../../components/Card/Card.jsx';
import AlertError from '../../Components/AlertError.jsx';
import Button from '../../../elements/CustomButton/CustomButton.jsx';
import Select from 'react-select';
import ModalTarea from './ModalTarea.jsx';
import ProyectService from "../../../services/ProyectService";
import IncubationService from "../../../services/IncubationService";
import AdministrationService from "../../../services/AdministrationService";
import HighlightsService from "../../../services/HighlightsService";
import UserService from "../../../services/UserService";
import RegistrosTab from './RegistrosTab.jsx';
import AdministracionTab from './AdministracionTab.jsx';
import ContratoTab from './ContratoTab.jsx';

class IncubationPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectId: this.props.currentUser.roles[0] === 'Emprendedores' ? this.props.currentUser.project : this.props.match.params.number,
      state: this.props.match.params.state,
      modal: {
        open: false,
        id: null,
      },
      currentTask: null,
      project: null,
      alert: null,
      RAT: [],
      RT: [],
      RM: [],
      SAF: [],
      SS: [],
      compras: null,
      ventas: null,
      rendiciones: null,
      contrato: null,
      usersContracts: null,
      estadisticas: null,
      highlights: null,
    };
    this.highlightsService = new HighlightsService();
    this.proyectService = new ProyectService();
    this.userService = new UserService();
    this.incubationService = new IncubationService();
    this.administrationService = new AdministrationService();
    this.generateTableContent = this.generateTableContent.bind(this);
    this.errorAlert = this.errorAlert.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.saveTask = this.saveTask.bind(this);
    this.getProject = this.getProject.bind(this);
    this.confirmDelete = this.confirmDelete.bind(this);
    this.deleteTask = this.deleteTask.bind(this);
    this.onChangeName = this.onChangeName.bind(this);
    this.onChangeDescription = this.onChangeDescription.bind(this);
    this.onChangeEstado = this.onChangeEstado.bind(this);
    this.onChangeSituacion = this.onChangeSituacion.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.getRAT = this.getRAT.bind(this);
    this.getRT = this.getRT.bind(this);
    this.getRM = this.getRM.bind(this);
    this.refreshRAT = this.refreshRAT.bind(this);
    this.refreshRT = this.refreshRT.bind(this);
    this.refreshRM = this.refreshRM.bind(this);
    this.refreshSS = this.refreshSS.bind(this);
    this.refreshSAF = this.refreshSAF.bind(this);
    this.getMentors = this.getMentors.bind(this);
    this.getFacturasCompra = this.getFacturasCompra.bind(this);
    this.getFacturasVenta = this.getFacturasVenta.bind(this);
    this.getActualContract = this.getActualContract.bind(this);
    this.getRendiciones = this.getRendiciones.bind(this);
    this.rendirFacturas = this.rendirFacturas.bind(this);
    this.getUsersContracts = this.getUsersContracts.bind(this);
    this.saveFactura = this.saveFactura.bind(this);
    this.editProject = this.editProject.bind(this);
    this.refreshContracts = this.refreshContracts.bind(this);
    this.getProjectStatistics = this.getProjectStatistics.bind(this);
    this.getHighlights = this.getHighlights.bind(this);
    this.onChangePValor = this.onChangePValor.bind(this);
  }

  componentDidMount() {
    this.getProject();
    this.getMentors();
    this.getRAT();
    this.getRM();
    this.getRT();
    this.getSS();
    this.getSAF();
    this.getFacturasCompra();
    this.getFacturasVenta();
    this.getActualContract();
    this.getRendiciones();
    this.getUsersContracts();
    this.getProjectStatistics();
    this.getHighlights();
  }

  getHighlights() {
    this.highlightsService.getHighlights(this.state.projectId)
    .then(res => {
      this.setState({ highlights: res.highlights });
    })
    .catch(err => {
      this.errorAlert(
        <div>
          Ha ocurrido un error mientras se cargaba la información, el servidor ha
          devuelto la siguiente información: <p>{err.message}</p>
        </div>
      );
    });
  }

  getProjectStatistics() {
    this.incubationService.getProjectStatistics(this.state.projectId)
    .then(res => {
      this.setState({ estadisticas: res['main-statistics'] });
    })
    .catch(err => {
      this.errorAlert(
        <div>
          Ha ocurrido un error mientras se cargaba la información, el servidor ha
          devuelto la siguiente información: <p>{err.message}</p>
        </div>
      );
    });
  }

  getUsersContracts() {
    this.incubationService
      .getUsersContracts(this.state.projectId)
      .then(res => {
        this.setState({ usersContracts: res['users-contracts'].contratos });
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se cargaba la información, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  getFacturasCompra() {
    this.incubationService
      .getFacturasCompra(this.state.projectId)
      .then(res => {
        this.setState({ compras: res.facturas });
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se cargaba la información, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  getFacturasVenta() {
    this.incubationService
      .getFacturasVenta(this.state.projectId)
      .then(res => {
        this.setState({ ventas: res.facturas });
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se cargaba la información, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  getActualContract() {
    this.incubationService
      .getActualContract(this.state.projectId)
      .then(res => {
        this.setState({ contrato: res['actual-contract'] });
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se cargaba la información, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  getRendiciones() {
    this.incubationService
      .getRendiciones(this.state.projectId)
      .then(res => {
        this.setState({ rendiciones: res.rendiciones });
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se cargaba la información, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  getMentors() {
    this.userService
      .getUserByRole(7) // id de mentores = 7
      .then(res => {
        this.setState({ mentores: res.users });
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se cargaba la información de los usuarios, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  getProject() {
    this.proyectService
      .getIncubationProject(this.state.projectId, this.state.state)
      .then(res => {
        this.setState({ project: res.proyecto });
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se cargaba la información del proyecto, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }
  getRAT() {
    this.incubationService
      .getRATList(this.state.projectId)
      .then( res => {
        this.setState({ RAT: res.RAT });
      })
      .catch( err => {
        this.errorAlert((<div>Ha ocurrido un error mientras se cargaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }
  getRT() {
    this.incubationService
      .getRTList(this.state.projectId)
      .then( res => {
        this.setState({ RT: res.RT });
      })
      .catch( err => {
        this.errorAlert((<div>Ha ocurrido un error mientras se cargaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }
  getRM() {
    this.incubationService
      .getRMList(this.state.projectId)
      .then( res => {
        this.setState({ RM: res.RM });
      })
      .catch( err => {
        this.errorAlert((<div>Ha ocurrido un error mientras se cargaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }
  getSAF() {
    this.incubationService
      .getSAFList(this.state.projectId)
      .then( res => {
        this.setState({ SAF: res.SAF });
      })
      .catch( err => {
        this.errorAlert((<div>Ha ocurrido un error mientras se cargaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }
  getSS() {
    this.incubationService
      .getSSList(this.state.projectId)
      .then( res => {
        this.setState({ SS: res.SS });
      })
      .catch( err => {
        this.errorAlert((<div>Ha ocurrido un error mientras se cargaban los datos, el servidor ha devuelto la siguiente información: <p>{err.message}</p></div>));
      });
  }

  errorAlert(message) {
    this.setState({
      alert: (
        <AlertError hideAlert={this.hideAlert} message={message} />
      )
    });
  }

  hideAlert() {
    this.setState({
      alert: null
    });
  }

  showAlert(message) {
    this.setState({ alert: message });
  }

  generateTableContent() {
    const html = [];
    const remove = (<Tooltip id="remove_tooltip">Eliminar</Tooltip>);
    const edit = (<Tooltip id="remove_tooltip">Editar</Tooltip>);
    let tareas = this.state.project.tareas;
    tareas.forEach((tarea) => {
      html.push(
        <tr key={tarea.id}>
          <td className="success">{tarea.nombre}</td>
          <td>{tarea.fechainicio}</td>
          <td>{tarea.fechafin}</td>
          <td>{tarea.porcentaje}%</td>
          <td>
            <OverlayTrigger placement="top" overlay={edit}>
              <Button
                simple
                onClick={() => this.setState({ modal: {open: true, id: tarea.id}, currentTask: tarea})}
              >
                <i className="fa fa-edit"></i>
              </Button>
            </OverlayTrigger>
            <OverlayTrigger placement="top" overlay={remove}>
              <Button simple onClick={() => this.confirmDelete(tarea.id, this.state.projectId)}>
                <i className="fa fa-trash"></i>
              </Button>
            </OverlayTrigger>
          </td>
        </tr>
      );
    });
    return html;
  }

  saveTask(tarea) {
    this.proyectService.saveTask(tarea, this.state.project.id)
      .then(res => {
        this.setState({ modal: { open: false, id: null } });
        this.getProject();
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Tarea guardada satisfactoriamente!</div>), 10);
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se cargaba la información del proyecto, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  saveFactura(factura, callback) {
    this.incubationService.postFactura(factura, this.state.projectId)
      .then(res => {
        this.getFacturasCompra();
        this.getFacturasVenta();
        this.props.pushNotification('success', 'tc', 'pe-7s-check', (<div>Factura guardada satisfactoriamente!</div>), 10);
        callback();
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se guardaba la información del proyecto, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  confirmDelete(idTarea, idProyecto) {
    this.setState({
      alert: (
        <SweetAlert
          warning
          style={{ display: "block", marginTop: "-100px" }}
          title="Borrar"
          onConfirm={() => this.deleteTask(idTarea, idProyecto)}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Sí, bórrala!"
          cancelBtnText="Cancelar"
          showCancel
        >
          ¿Está seguro de borrar la tarea?
        </SweetAlert>
      )
    });
  }

  deleteTask(idTarea, idProyecto) {
    this.hideAlert();
    this.proyectService.deleteTask(idTarea, idProyecto)
      .then(res => {
        this.setState({
          alert: (
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Borrado!"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              La tarea ha sido borrada satisfactoriamente
            </SweetAlert>
          )
        });
        this.getProject();
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se eliminaba la tarea, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  onChangeName(value) {
    const auxState = this.state.project;
    auxState.nombre = value;
    this.setState({ project: auxState, errorNombre: false });
  }

  onChangeDescription(value) {
    const auxState = this.state.project;
    auxState.descripcion = value;
    this.setState({ project: auxState, errorDesripcion: false });
  }

  onChangePValor(value) {
    const auxState = this.state.project;
    auxState.pvalor = value;
    this.setState({ project: auxState, errorPValor: false });
  }
  onChangeEstado(e) {
    const auxState = this.state.project;
    auxState.estado = e.value;
    this.setState({ project: auxState, errorEstado: false });
  }
  onChangeSituacion(e) {
    const auxState = this.state.project;
    auxState.situacion = e.value;
    this.setState({ project: auxState, errorSituacion: false });
  }
  editProject() {
    let error = false;
    if (!this.state.project.nombre || this.state.project.nombre === '') {
      error = true;
      this.setState({errorNombre: true});
    }
    if (!this.state.project.descripcion || this.state.project.descripcion === '') {
      error = true;
      this.setState({errorDesripcion: true});
    }

    if (!error) {
      this.proyectService
      .editProject(this.state.project)
      .then(res => {
        this.setState({
          alert: (
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Listo!"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              Proyecto actualizado exitosamente!
            </SweetAlert>
            )
          });
        })
        .catch(err => {
          this.errorAlert(
            <div>
              Ha ocurrido un error mientras se actualizaban los datos, el servidor ha
              devuelto la siguiente información: <p>{err.message}</p>
            </div>
          );
        });
    } else {
      this.errorAlert(
        <div>
          Uno o mas campos contienen errores o no han sido completados!
        </div>);
    }
  }

  rendirFacturas(rendicion) {
    this.incubationService
      .postRendiciones(rendicion)
      .then(res => {
        this.setState({
          alert: (
            <SweetAlert
              success
              style={{ display: "block", marginTop: "-100px" }}
              title="Listo!"
              onConfirm={() => this.hideAlert()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
              confirmBtnText="Aceptar"
            >
              Rendición realizada exitosamente!
            </SweetAlert>
          )
        });
        // Hacer get de las facturas y rendiciones que se actualizaron con el POST
        this.getFacturasCompra();
        this.getFacturasVenta();
        this.getRendiciones();
      })
      .catch(err => {
        this.errorAlert(
          <div>
            Ha ocurrido un error mientras se realizaba la rendición, el servidor ha
            devuelto la siguiente información: <p>{err.message}</p>
          </div>
        );
      });
  }

  refreshRAT() {
    this.getRAT();
    this.getHighlights();
  }

  refreshRT() {
    this.getRT();
    this.getHighlights();
  }

  refreshRM() {
    this.getRM();
    this.getHighlights();
  }

  refreshSS() {
    this.getSS();
  }

  refreshSAF() {
    this.getSAF();
  }

  refreshContracts() {
    this.getUsersContracts();
    this.getActualContract();
  }

  render () {
    if (!this.state.project || !this.state.estadisticas || !this.state.highlights) {
      return(<div className="main-content"></div>);
    }
    return (
      <div className="main-content">
        {this.state.alert}
        <Grid fluid={true}>
          <Row>
            <Col md={12}>
              <Card
                content={
                  <div>
                    <div>
                      <Tabs activeKey={this.state.key} onSelect={this.handleSelect} id="incubacion-tabs">
                        <Tab eventKey={1} title="Info">
                          <div style={{ textAlign: "right", paddingBottom: 5}}>
                            <Button bsStyle="primary" fill wd onClick={this.editProject}>
                              Guardar
                            </Button>
                          </div>
                          <Row>
                            <Col md={12}>
                              <Form>
                                <FormGroup validationState={this.state.errorNombre ? 'error': null}>
                                  <ControlLabel>{'Nombre'}</ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.project.nombre}
                                    onChange={(e) => this.onChangeName(e.target.value)}
                                  />
                                </FormGroup>
                              </Form>
                            </Col>
                            <Col md={6}>
                              <Form>
                                <FormGroup validationState={this.state.errorEstado ? 'error': null}>
                                <ControlLabel>{'Estado'}</ControlLabel>
                                <Select
                                  placeholder="Seleccione una Estado"
                                  closeOnSelect={true}
                                  name="estadoSelect"
                                  value={parseInt(this.state.project.estado)}
                                  options={[
                                    { value: 1, label: 'Activo' },
                                    { value: 0, label: 'Inactivo' },
                                  ]}
                                  onChange={(value) => this.onChangeEstado(value)}
                                />
                                </FormGroup>
                              </Form>
                            </Col>
                            <Col md={6}>
                              <Form>
                                <FormGroup validationState={this.state.errorSituacion ? 'error': null}>
                                <ControlLabel>{'Situación'}</ControlLabel>
                                <Select
                                  placeholder="Seleccione una Situación"
                                  closeOnSelect={true}
                                  name="estadoSelect"
                                  value={parseInt(this.state.project.situacion)}
                                  options={[
                                    { value: 1, label: 'Completo' },
                                    { value: 0, label: 'Incompleto' },
                                  ]}
                                  onChange={(value) => this.onChangeSituacion(value)}
                                />
                                </FormGroup>
                              </Form>
                            </Col>
                            <Col md={4}>
                              <Form>
                                <FormGroup validationState={this.state.errorDesripcion ? 'error': null}>
                                  <ControlLabel>{'Descripcion'}</ControlLabel>
                                  <FormControl
                                    componentClass="textarea" type="text" style={{height: 300}}
                                    value={this.state.project.descripcion}
                                    onChange={(e) => this.onChangeDescription(e.target.value)}
                                  />
                                </FormGroup>
                              </Form>
                            </Col>
                            <Col md={4}>
                              <Form>
                                <FormGroup validationState={this.state.errorDesripcion ? 'error': null}>
                                  <ControlLabel>{'Propuesta de Valor'}</ControlLabel>
                                  <FormControl
                                    componentClass="textarea" type="text" style={{height: 300}}
                                    value={this.state.project.pvalor || ''}
                                    onChange={(e) => this.onChangePValor(e.target.value)}
                                  />
                                </FormGroup>
                              </Form>
                            </Col>
                            <Col md={4}>
                              <Form>
                                <FormGroup>
                                  <ControlLabel>{'Estadísticas'}</ControlLabel>
                                  <div style={{maxHeight: 300, overflowY: 'auto'}}>
                                    <Table
                                      bordered condensed responsive
                                    >
                                      <tbody>
                                      <tr>
                                        <td>Convocatoria</td>
                                        <td style={{textAlign: 'right'}}>{this.state.estadisticas.convocatoria[0].numero}</td>
                                      </tr>
                                      {this.state.estadisticas.equipo.length > 0 ?
                                        this.state.estadisticas.equipo.map((usuario, index) => {
                                          if (index === 0) {
                                            return (
                                              <tr key={index}>
                                                <td>Equipo</td>
                                                <td style={{textAlign: 'right'}}>{usuario.username}</td>
                                              </tr>
                                            );
                                          } else {
                                            return (
                                              <tr key={index}>
                                                <td></td>
                                                <td style={{textAlign: 'right'}}>{usuario.username}</td>
                                              </tr>
                                            )
                                          }
                                        }) :
                                        <tr>
                                          <td>Equipo</td>
                                          <td style={{textAlign: 'right'}}>No hay miembros en el equipo</td>
                                        </tr>
                                      }
                                      <tr>
                                        <td>Horas Asistencia Técnica</td>
                                        {this.state.estadisticas['horas-asistencia-tecnica'].length > 0 ?
                                          <td style={{textAlign: 'right'}}>{this.state.estadisticas['horas-asistencia-tecnica'][0].horas}</td> :
                                          <td style={{textAlign: 'right'}}>0</td>
                                        }
                                      </tr>
                                      <tr>
                                        <td>Horas Tutorías</td>
                                        {this.state.estadisticas['horas-tutoria'].length > 0 ?
                                          <td style={{textAlign: 'right'}}>{this.state.estadisticas['horas-tutoria'][0].horas}</td> :
                                          <td style={{textAlign: 'right'}}>0</td>
                                        }
                                      </tr>
                                      <tr>
                                        <td>Horas Mentorías</td>
                                        {this.state.estadisticas['horas-mentoria'].length > 0 ?
                                          <td style={{textAlign: 'right'}}>{this.state.estadisticas['horas-mentoria'][0].horas}</td> :
                                          <td style={{textAlign: 'right'}}>0</td>
                                        }
                                      </tr>
                                      <tr>
                                        <td>Solicitudes de Servicios</td>
                                        {this.state.estadisticas['solicitudes-servicios'].length > 0 ?
                                          <td style={{textAlign: 'right'}}>{this.state.estadisticas['solicitudes-servicios'][0].total}</td> :
                                          <td style={{textAlign: 'right'}}>0</td>
                                        }
                                      </tr>
                                      <tr>
                                        <td>Solicitudes de Asistencia Financiera</td>
                                        {this.state.estadisticas['solicitudes-asistencia-financiera'].length > 0 ?
                                          <td style={{textAlign: 'right'}}>{this.state.estadisticas['solicitudes-asistencia-financiera'][0].total}</td> :
                                          <td style={{textAlign: 'right'}}>0</td>
                                        }
                                      </tr>
                                      <tr>
                                        <td>Monto Solicitudes de Asistencia Financiera</td>
                                        {this.state.estadisticas['monto-solicitudes-asistencia-financiera'][0].total ?
                                          <td style={{textAlign: 'right'}}>${this.state.estadisticas['monto-solicitudes-asistencia-financiera'][0].total}</td> :
                                          <td style={{textAlign: 'right'}}>0</td>
                                        }
                                      </tr>
                                      <tr>
                                        <td>Ventas</td>
                                        {this.state.estadisticas.ventas[0].total ?
                                          <td style={{textAlign: 'right'}}>${this.state.estadisticas.ventas[0].total}</td> :
                                          <td style={{textAlign: 'right'}}>No hay ventas</td>
                                        }
                                      </tr>
                                      </tbody>
                                    </Table>
                                  </div>
                                </FormGroup>
                              </Form>
                            </Col>
                          </Row>
                          {this.state.highlights.length > 0 &&
                            <Row>
                              <Col md={12}>
                                <FormGroup>
                                  <ControlLabel>{'Notas destacadas'}</ControlLabel>
                                  <Slider
                                    infinite
                                    arrows={false}
                                    slidesToShow={this.state.highlights.length > 5 ? 5 : this.state.highlights.length}
                                    slidesToScroll={1}
                                    autoplay
                                    autoplaySpeed={5000}
                                    vertical
                                    verticalSwiping
                                    focusOnSelect
                                  >
                                    {this.state.highlights.map((item, index) => {
                                      return(
                                        <div key={index}>
                                          <FormGroup style={{marginLeft: 10}}>
                                            <ControlLabel style={{paddingTop: 10}}>{item.campo}</ControlLabel>
                                            <small style={{display: 'inline'}}>{` (Creada el ${item.created})`}</small>
                                            <FormControl.Static>{item.nota}</FormControl.Static>
                                          </FormGroup>
                                        </div>
                                      );
                                    })}
                                  </Slider>
                                </FormGroup>
                              </Col>
                            </Row>
                          }
                        </Tab>
                        <Tab eventKey={2} title="Tareas">
                          <div style={{ textAlign: "right", paddingBottom: 5}}>
                            <Button bsStyle="primary" bsSize="sm" fill wd onClick={() => this.setState({ modal: { open: true, id: null }})}>
                              Nueva Tarea
                            </Button>
                          </div>
                          <div style={{ with: 'auto',overflow: 'auto'}}>
                            <Table striped bordered condensed hover>
                              <thead>
                                <tr>
                                  <th>Tarea</th>
                                  <th>Fecha Inicio</th>
                                  <th>Fecha Fin</th>
                                  <th>% completo</th>
                                  <th style={{width: '150px'}}>
                                    Acciones
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {this.generateTableContent()}
                              </tbody>
                            </Table>
                            {this.state.project.tareas.length === 0 &&
                              <div style={{textAlign: 'center'}} >No hay tareas cargadas</div>
                            }
                          </div>
                        </Tab>
                        {this.props.currentUser.roles[0] !== 'Emprendedores' &&
                          <Tab eventKey={3} title="Registros">
                            <RegistrosTab
                              project={this.state.project} state={this.state.state}
                              incubationService={this.incubationService} showAlert={this.showAlert}
                              hideAlert={this.hideAlert} setError={this.errorAlert}
                              RATList={this.state.RAT} refreshRAT={this.refreshRAT}
                              RMList={this.state.RM} refreshRM={this.refreshRM}
                              RTList={this.state.RT} refreshRT={this.refreshRT}
                              SAFList={this.state.SAF} refreshSAF={this.refreshSAF}
                              SSList={this.state.SS} refreshSS={this.refreshSS}
                              mentores={this.state.mentores}
                            />
                          </Tab>
                        }
                        <Tab eventKey={4} title="Administración">
                          <AdministracionTab
                            showAlert={this.showAlert}
                            hideAlert={this.hideAlert} setError={this.errorAlert}
                            compras={this.state.compras} ventas={this.state.ventas}
                            contrato={this.state.contrato} rendiciones={this.state.rendiciones}
                            rendirFacturas={this.rendirFacturas} saveFactura={this.saveFactura}
                            projectIncubationId={this.state.projectId} incubationService={this.incubationService}
                          />
                        </Tab>
                        {this.props.currentUser.roles[0] !== 'Emprendedores' &&
                          <Tab eventKey={5} title="Contratos">
                            <ContratoTab
                              showAlert={this.showAlert} incubationService={this.incubationService}
                              hideAlert={this.hideAlert} setError={this.errorAlert}
                              usersContracts={this.state.usersContracts} projectId={this.state.projectId}
                              refreshContracts={this.refreshContracts}
                            />
                          </Tab>
                        }
                      </Tabs>
                    </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {this.state.modal.open &&
          <ModalTarea
            tarea={this.state.modal.id ? this.state.currentTask : null}
            show={this.state.modal.open}
            closeModal={() => this.setState({ modal: {open: false, id: null}})}
            saveChanges={this.saveTask}
            projectId={this.state.project.id}
            proyectService={this.proyectService}
            pushNotification={this.props.pushNotification}
            errorAlert={this.errorAlert}
          />
        }
      </div>
    );
  }
}

export default IncubationPage;



// WEBPACK FOOTER //
// ./src/views/Incubation/IncubationPage/Main.jsx